angular.module('ui-ng-calendar').factory('executeCommandInSerial', function () {
  let queue = [];

  let _execute = function () {
    if (!_.isEmpty(queue)) {
      let command = queue[0];
      command().finally(function () {
        queue.shift();
        _execute();
      });
    }
  };

  return function (command) {
    queue.push(command);
    if (queue.length <= 1) {
      _execute();
    }
  };
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/utility/execute_command_in_serial.es.js